import { Stat } from '../../api';
import MonthBarChart from './MonthBarChart';

function getArrays(data: Stat, viewMode: string) {
  if (viewMode == 'transfer')
    return [
      data?.record?.hls?.playlist?.bytes
        ? data.record.hls.playlist.bytes.map((value: number) => {
            return value / 1000000;
          })
        : [],
      data?.record?.hls?.chunklist?.bytes
        ? data.record.hls.chunklist.bytes.map((value: number) => {
            return value / 1000000;
          })
        : [],
      data?.record?.hls?.media?.bytes
        ? data.record.hls.media.bytes.map((value: number) => {
            return value / 1000000;
          })
        : [],
    ];
  else if (viewMode == 'notfound') return data?.record?.hls?.notFound ? [data.record.hls.notFound] : [[]];
  else return data?.record?.hls?.playlist?.count ? [data.record.hls.playlist.count] : [[]];
}
function getTitle(viewMode: string, day: number): string {
  if (viewMode == 'transfer') return `Record HLS bandwidth usage (MB) by ${day ? 'hour' : 'day'}`;
  else if (viewMode == 'notfound') return `Record HLS download fails by ${day ? 'hour' : 'day'}`;
  else return `Record HLS accesses by ${day ? 'hour' : 'day'}`;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getUnit(viewMode: string, day: number | undefined): string {
  if (viewMode == 'transfer') return 'MB';
  if (viewMode == 'notfound') return 'fails';
  return 'accesses';
}

export default function MonthCameraRecordHlsChart(props: {
  stat: Stat;
  offset: number;
  daysInMonth: number;
  viewMode: string;
  day: number;
  month: number;
  year: number;
  tz: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options?: any;
  onChangeDay: (d: number) => void;
}) {
  return <MonthBarChart getUnit={getUnit} getTitle={getTitle} getArrays={getArrays} {...props} />;
}
